import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  localData: any;
  paymentUrl: any;
  constructor(private http: HttpClient, private store: Store<any>) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data.authReducer;
        this.paymentUrl =
          data.authReducer.businessDetails?.settings_data?.DIGITAL_ORDERING_DOMAIN;
      });
  }

  paymentStatus(data) {
    return this.http.post<any>(
      `${this.paymentUrl}/businesses/${this.localData?.userDetails?.business?.id}/payment_status`,
      data
    );
  }

  paymentStatusPaymongoPaynamics(data) {
    return this.http.post<any>(
      `${this.paymentUrl}/businesses/${this.localData?.userDetails?.business?.id}/get_online_payment_status`,
      data
    );
  }

  payment(page) {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/fetch_payment_months?page=${page}`
    );
  }

  fetchPayementData(fromDate, todate) {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/probase_payment?fromDate=${fromDate}&toDate=${todate}`
    );
  }
}
